import React from 'react';

const TierDescription = ({ description }: any) => (
  <p className="mt-4 mb-6 h-20 text-sm text-gray-500">{description}</p>
);

export default TierDescription;
